// ... existing code ...

import { Dropdown, DownOutlined } from 'gokwik-ui-kit'

export const PropertySelector = ({ data, parameters, setParameters }) => {
    const handleMenuClick = (e: any) => {
        setParameters((prevParams) => ({
            ...prevParams,
            property_id: e.key,
        }))
    }

    const items = data?.propertyList.map((property) => ({
        key: String(property?.property_id),
        label: `${property?.property_id}`,
    }))

    return (
        <div className='flex items-center justify-between border-[#D0D5DD] border-solid p-2 rounded-lg bg-white w-full'>
            <div className='flex flex-col'>
                <div className='font-normal text-xs text-[#667085]'>Property ID:</div>
                <div className='text-xs font-semibold text-[#0C111D]'>{parameters?.property_id}</div>
            </div>

            <Dropdown
                className='cursor-pointer'
                menu={{
                    items,
                    selectable: true,
                    defaultSelectedKeys: [parameters?.property_id],
                    onClick: handleMenuClick,
                }}
                trigger={['click']}
            >
                <span className='border border-solid border-[#D0D5DD] p-2 rounded-md'>
                    Switch Property Id &nbsp;&nbsp;
                    <DownOutlined />
                </span>
            </Dropdown>
        </div>
    )
}
